; (function() {

	const QUEUE_LENGTH = 3;
	let notices = null;

	class Notices {
		constructor(container) {
			this.container = container;
			this.queue = [];
			this.maxLength = QUEUE_LENGTH;
		}

		push(message) {
			this.shrink(this.maxLength - 1);

			let element = document.createElement("div");
			element.classList.add("notice", "notice-collapsed");
			element.innerHTML = "<div class='form-row align-items-center'><div class='col'>" + message + "</div><div class='col-auto'><a href='#' class='btn btn-sm' data-notice='close'>&times;</a></div></div>";

			this.container.insertBefore(element, this.container.firstChild);
			element.offsetHeight; // Animace
			element.classList.remove("notice-collapsed");

			let item = {
				element: element,
				interval: setTimeout(this.remove.bind(this, element), 3500)
			};

			this.queue.push(item);
		}

		remove(element) {
			let index = this.queue.findIndex(function(row) { return row.element == element; });
			if (index < 0) {
				return;
			}

			let item = this.queue[index];
			if (item.interval) {
				clearTimeout(item.interval);
			}

			item.element.classList.add("notice-collapsed");
			setTimeout(function() { item.element.remove(); }, 600);

			this.queue.splice(index, 1);
		}

		shrink(length) {
			while (0 < length && length < this.queue.length) {
				let item = this.queue[0];
				this.remove(item.element);
			}
		}
	}


	// *************************************************************************
	// Události
	// *************************************************************************

	document.addEventListener("ajaxsuccess", function(event) {
		let data = event.detail.responseJSON;
		let messages = data.notices;
		if (!messages) {
			return;
		}

		let container = document.querySelector(".notices");
		if (!notices) {
			notices = new Notices(container);
		}

		for (let message of messages) {
			notices.push(message);
		}
	});

	document.addEventSelectorListener("click", "[data-notice='close']", function(event, target) {
		let notice = target.closest(".notice");
		event.preventDefault();
		notices.remove(notice);
	});

}());